import React from 'react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-paper-dark pt-16 pb-28 md:py-16 px-6 md:px-12 border-t border-gray-200 mt-0" data-id="element-168">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-169">
        <Logo data-id="element-170" />
        <div className="text-sm text-text-muted text-center md:text-right font-medium" data-id="element-171">
          <p data-id="element-172">
            &copy; {new Date().getFullYear()} Author Leverage. All rights
            reserved.
          </p>
          <p className="mt-2 text-seaglass" data-id="element-173">The path after the book.</p>
        </div>
      </div>
    </footer>;
}